/* ============================================================
   CUSTOM BOTTOMS — Home v5 motion + interaction (Shopify build)
   ============================================================ */
(() => {
  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveal on scroll ---------- */
  const revealIO = new IntersectionObserver((entries) => {
    for (const e of entries) if (e.isIntersecting) { e.target.classList.add('in'); revealIO.unobserve(e.target); }
  }, { threshold: 0.15 });
  $$('.reveal, [data-stagger], .statement').forEach(el => revealIO.observe(el));

  /* ---------- animated counters ---------- */
  const countIO = new IntersectionObserver((entries) => {
    for (const e of entries) {
      if (!e.isIntersecting) continue;
      countIO.unobserve(e.target);
      const el = e.target;
      const target = parseFloat(el.dataset.count);
      const decimals = +(el.dataset.decimals || 0);
      const suffix = el.dataset.suffix || '';
      if (reduced) { el.textContent = target.toFixed(decimals) + suffix; continue; }
      const t0 = performance.now(), dur = 1600;
      const tick = (t) => {
        const p = Math.min((t - t0) / dur, 1);
        const eased = 1 - Math.pow(1 - p, 4);
        el.textContent = (target * eased).toFixed(decimals) + suffix;
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }
  }, { threshold: 0.5 });
  $$('[data-count]').forEach(el => countIO.observe(el));

  /* ---------- scrollytelling scenes ---------- */
  const steps = $$('.scrolly-step');
  const scenes = $$('.scene');
  if (steps.length) {
    const activate = (i) => {
      steps.forEach((s, j) => s.classList.toggle('active', i === j));
      scenes.forEach((s, j) => s.classList.toggle('on', i === j));
    };
    activate(0);

    // On mobile the sticky image takes ~50vw of the viewport from the top.
    // Use a tighter rootMargin so steps trigger when they enter the lower half.
    const isMobile = window.matchMedia('(max-width: 920px)').matches;
    const margin = isMobile ? '-55% 0px -10% 0px' : '-45% 0px -45% 0px';

    const stepIO = new IntersectionObserver((entries) => {
      for (const e of entries) if (e.isIntersecting) activate(steps.indexOf(e.target));
    }, { rootMargin: margin });
    steps.forEach(s => stepIO.observe(s));
  }

  /* ---------- before / after slider ---------- */
  const ba = $('#ba');
  if (ba) {
    const handle = ba.querySelector('.ba-handle');
    const set = (clientX) => {
      const r = ba.getBoundingClientRect();
      const p = Math.min(Math.max((clientX - r.left) / r.width, 0.06), 0.94);
      ba.style.setProperty('--pos', (p * 100).toFixed(2) + '%');
    };
    let down = false;
    if (handle) {
      handle.addEventListener('pointerdown', (e) => { down = true; handle.setPointerCapture(e.pointerId); e.preventDefault(); });
      handle.addEventListener('pointermove', (e) => down && set(e.clientX));
      window.addEventListener('pointerup', () => { down = false; });
      handle.addEventListener('pointercancel', () => { down = false; });
    }
    const imgs = $$('img.ba-ar-src', ba);
    const apply = () => {
      const img = imgs.find(i => i.naturalWidth);
      if (img) ba.style.setProperty('--ba-ar', img.naturalWidth + ' / ' + img.naturalHeight);
    };
    imgs.forEach(img => { if (img.complete) apply(); img.addEventListener('load', apply); });
  }

  /* ---------- review marquee rows: clone for seamless loop ---------- */
  $$('.rev-row').forEach(row => {
    const track = row.querySelector('.rev-track');
    if (!track) return;
    const clone = track.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    row.appendChild(clone);
  });

  /* ---------- bundle picker ---------- */
  const bundles = $$('.bundle');
  const priceEls = $$('[data-cta-price]');
  const wasEls = $$('[data-cta-was]');
  const labelEls = $$('[data-cta-label]');
  const selectBundle = (btn) => {
    bundles.forEach(b => {
      const on = b === btn;
      b.classList.toggle('selected', on);
      b.setAttribute('aria-pressed', on);
    });
    priceEls.forEach(el => el.textContent = '$' + btn.dataset.price);
    wasEls.forEach(el => el.textContent = '$' + btn.dataset.was);
    labelEls.forEach(el => el.textContent = btn.dataset.label);
  };
  bundles.forEach(b => b.addEventListener('click', () => selectBundle(b)));
  const preselected = $('.bundle.selected') || bundles[0];
  if (preselected) selectBundle(preselected);

  /* ---------- FAQ accordion ---------- */
  const initFaq = () => {
    $$('.faq-item').forEach(item => {
      if (item.dataset.faqInit) return;
      item.dataset.faqInit = '1';
      const q = item.querySelector('.faq-q');
      const a = item.querySelector('.faq-a');
      if (!q || !a) return;
      q.addEventListener('click', () => {
        const open = item.classList.contains('open');
        $$('.faq-item.open').forEach(o => {
          o.classList.remove('open');
          const oa = o.querySelector('.faq-a');
          if (oa) oa.style.maxHeight = '0px';
          const oq = o.querySelector('.faq-q');
          if (oq) oq.setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          item.classList.add('open');
          a.style.maxHeight = a.scrollHeight + 'px';
          q.setAttribute('aria-expanded', 'true');
        }
      });
    });
  };
  initFaq();
  document.addEventListener('shopify:section:load', initFaq);

  /* ---------- sticky CTA bar ---------- */
  const bar = $('#stickyCta');
  const hero = $('.hero');
  const offer = $('#offer');
  if (bar && hero) {
    let pastHero = false, offerVisible = false;
    const update = () => bar.classList.toggle('show', pastHero && !offerVisible);
    new IntersectionObserver(([e]) => { pastHero = !e.isIntersecting; update(); }, { threshold: 0.05 })
      .observe(hero);
    if (offer) new IntersectionObserver(([e]) => { offerVisible = e.isIntersecting; update(); }, { threshold: 0.15 })
      .observe(offer);
  }
})();